@if (notify.toasts().length > 0) {
  <!-- `role="status"` + polite: a success is worth announcing, but never worth interrupting. -->
  <div class="vf-toasts" role="status" aria-live="polite">
    @for (toast of notify.toasts(); track toast.id) {
      <div class="vf-toast">
        <span class="vf-toast__text">{{ toast.messageKey | translate }}</span>
        <button type="button" class="vf-toast__close"
                [attr.aria-label]="'notify_dismiss' | translate"
                (click)="notify.dismiss(toast.id)">&times;</button>
      </div>
    }
  </div>
}

@if (notify.error(); as notice) {
  <div class="vf-notice-backdrop" (click)="notify.dismissError()"></div>
  <div class="vf-notice" role="alertdialog" aria-modal="true" aria-labelledby="vf-notice-title">
    <h2 class="vf-notice__title" id="vf-notice-title">{{ notice.titleKey | translate }}</h2>
    <p class="vf-notice__message">{{ notice.messageKey | translate }}</p>
    @if (notice.reasonKey; as reasonKey) {
      <p class="vf-notice__reason">{{ reasonKey | translate }}</p>
    }
    @if (notice.reasonText; as reasonText) {
      <p class="vf-notice__reason">{{ reasonText }}</p>
    }
    <div class="vf-notice__actions">
      <button type="button" class="vf-btn vf-btn--primary" (click)="notify.dismissError()">
        {{ 'common_ok' | translate }}
      </button>
    </div>
  </div>
}
